import type { RouteHandle } from 'src/root';
import type { LoaderFunctionArgs } from 'react-router';
import type { ServerRendered } from 'src/server/catalog.server';

import { useLoaderData } from 'react-router';

import { useSession } from 'src/hooks/useSession';

import { Listing } from 'src/screens/Listing';
import { loadListing } from 'src/server/listing.server';

import { ServerAnswers } from 'src/components/ServerAnswers';

export const handle: RouteHandle = { serverRendered: true };

/** A car for sale, asked of the api by the server for the page it renders. */
export async function loader({ request, params }: LoaderFunctionArgs) {
  return loadListing(request, 'sale', params.id ?? '');
}

/** Every later visit is the browser's own: the screen asks the api itself, as it always did. */
export const clientLoader = () => null;

export default function ListingRoute() {
  const rendered = useLoaderData() as ServerRendered | null;
  const { isLoggedIn, account, hasLinkedWallet, isTMA, isPending } = useSession();

  return (
    <ServerAnswers rendered={rendered}>
      <Listing
        isLoggedIn={isLoggedIn}
        account={account}
        hasLinkedWallet={hasLinkedWallet}
        isTMA={isTMA}
        sessionPending={isPending}
      />
    </ServerAnswers>
  );
}
